import { useScreenSize } from '@frontends/ds';
import { useTheme } from '@frontends/util-theme-provider';
import { PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useEntityConfig } from '@/hooks/useEntityConfig.tsx';

const Mp4Files: Record<string, { default: string }> = import.meta.glob('@/assets/videos/*.mp4', { eager: true });

function AuthFormWrapper({ children }: PropsWithChildren) {
  const { isDesktop: isLargeDesktop } = useScreenSize();
  const { resolvedMode: theme } = useTheme();
  const { i18n } = useTranslation();
  const config = useEntityConfig();

  useEffect(() => {
    if (!isLargeDesktop) return;
  }, [isLargeDesktop, i18n.language, theme]);

  return (
    <div className="relative grid lg:min-h-[65svh] xl:min-h-[75svh] lg:grid-cols-2 lg:rounded-2xl lg:shadow-sm lg:bg-backgroundRaised w-full lg:w-fit mx-auto">
      <div className="flex flex-col self-center w-auto">
        <div className="flex flex-1 items-start justify-center z-10">
          <div className="w-full">{children}</div>
        </div>
      </div>

      {isLargeDesktop && (
        <div className="relative hidden lg:block aspect-1440/2732 w-auto h-full min-h-full max-h-[calc(100svh-var(--header-height)-3rem)] justify-self-stretch">
          <video
            src={Mp4Files[`/src/assets/videos/${config.VITE_ENTITY}-auth.mp4`]?.default}
            autoPlay
            loop
            muted
            playsInline
            className="absolute top-0 left-0 h-full w-full rounded-e-2xl max-w-full max-h-full min-w-full min-h-full object-cover"
          />
        </div>
      )}
    </div>
  );
}

export default AuthFormWrapper;
